import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { useVideoTime } from "../../../VideoContextProvider/context/state/time.js";
import RewindIcon from "./rewind-icon.svg.js";
const Rewind = () => {
  const { t } = useTranslation();
  const videoController = useVideoController();
  const { position } = useVideoTime();
  const handleClick = () => videoController.seekTo(position - 10);
  return /* @__PURE__ */ jsx("button", { onClick: handleClick, className: "omega_rewind", "aria-label": t("Rewind 10 Seconds"), children: /* @__PURE__ */ jsx("img", { src: RewindIcon, alt: t("Rewind Icon") }) });
};
export {
  Rewind
};
//# sourceMappingURL=index.js.map
